import Tab from 'bootstrap/js/dist/tab';
import { scrollIntoView } from '../../shared/lib/scroll-into-view.ts';

export default function loadAddReview($link: HTMLLinkElement) {
	const $tabReviews = document.querySelector<HTMLLinkElement>('a#reviews-tab');
	if ($tabReviews) {
		const $bsTabReviews = Tab.getOrCreateInstance($tabReviews);

		$link.addEventListener('click', () => {
			$bsTabReviews.show();
		});

		return;
	}

	const $sectionReviews = document.querySelector<HTMLElement>('section#reviews');
	if ($sectionReviews) {
		scrollIntoView($sectionReviews);
	}
}
